import { localStorageHelper } from './storage';

const STORAGE_KEY = 'vgtv/parentalControl';

function getStoredData(): { ageLimit?: number; pin?: string } {
  const rawData = localStorageHelper.getItem(STORAGE_KEY);
  if (!rawData) {
    return {};
  }

  try {
    const { ageLimit, pin } = JSON.parse(rawData);
    return { ageLimit, pin };
  } catch (err) {
    console.error(err);
    return {};
  }
}

const parentalControlsHelper = {
  setParentalLock(ageLimit: number, pin: string) {
    const data = { ageLimit, pin };
    localStorageHelper.setItem(STORAGE_KEY, JSON.stringify(data));
  },

  removeParentalLock() {
    localStorageHelper.removeItem(STORAGE_KEY);
  },

  isParentalLockSet() {
    const { ageLimit, pin } = getStoredData();

    return Boolean(ageLimit && pin);
  },

  getPin() {
    const { pin } = getStoredData();
    return pin;
  },

  isPinCorrect(userPin: string) {
    const { pin } = getStoredData();

    return userPin === pin;
  },

  isLocked(assetAgeLimit: number | null) {
    const { ageLimit } = getStoredData();

    if (ageLimit) {
      return (assetAgeLimit || 0) >= ageLimit;
    }

    return false;
  },
};

export { parentalControlsHelper };
